const siteRoutes = {
    home : "/",
    newOrder : "/order-2-0",
    orderComplete : "/complete/:orderId",
    paySuccess : "/success"
}

export default siteRoutes;
